<main class="auth-page min-vh-100 bg-white text-dark">
  <div class="row g-0 min-vh-100">
    <section class="col-lg-6 auth-brand-panel text-white p-4 p-lg-4 d-none d-lg-flex flex-column justify-content-between overflow-hidden position-relative bg-dark">
      <router-link to="/" class="auth-brand-mark d-inline-flex mb-3 align-self-start bg-white rounded-3 p-2" aria-label="Siyanda Platinum home">
        <span class="auth-brand-mark-img d-block" role="img" aria-label="Siyanda Bakgatla Platinum Mine"></span>
      </router-link>

      <div>
        <p class="text-uppercase text-warning fw-bold text-xxs mb-2">Account recovery</p>
        <h1 class="h3 fw-bold mb-2">Let's get you back into the Siyanda Platinum Platform.</h1>
        <p class="text-white-50 mb-0">
          Request a secure reset link and return to operational insights.
        </p>
      </div>

      <div>
        <hr class="my-3" />
        <div class="row g-3">
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Production</span>
            <span class="d-block fw-bold text-warning">Tracked daily</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Safety</span>
            <span class="d-block fw-bold text-warning">Always on</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Sustainability</span>
            <span class="d-block fw-bold text-warning">Community first</span>
          </div>
        </div>
      </div>
    </section>

    <section class="col-lg-6 bg-white text-dark d-flex align-items-center justify-content-center p-4 p-md-5">
      <div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-7">
        <h2 class="h3 fw-bold mb-2">Forgot your password?</h2>
        <p class="text-secondary mb-4">
          Enter your email and we'll send you a link to reset your password.
        </p>

        <SnackbarMessage
          :error-message="error_message"
          :success-message="success_message"
          @dismiss-error="error_message = ''"
          @dismiss-success="success_message = ''"
        />

        <div v-if="is_loading" class="text-center mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-secondary">Sending reset link...</span>
        </div>

        <form v-if="!is_loading" @submit.prevent="handleReset">
          <div class="mb-4">
            <label class="form-label fw-bold text-xs" for="reset-email">Email address</label>
            <input
              id="reset-email"
              v-model="email"
              type="email"
              class="form-control"
              placeholder="name@siyandaplatinum.com"
              autocomplete="email"
              required
              :disabled="is_loading"
            />
          </div>

          <button class="btn btn-primary w-100 py-2 mb-3" :disabled="is_loading">
            Send reset link
          </button>

          <p class="text-center text-secondary small mb-0">
            Remember your password?
            <router-link to="/login" class="fw-semibold text-primary">
              Sign in
            </router-link>
          </p>
        </form>
      </div>
    </section>
  </div>
</main>
